module.exports = __webpack_public_path__ + "static/img/link3.6ee53ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/links/link3.png
// module id = Sxyx
// module chunks = 12